import React, { Component } from 'react';
import {
  ShareButtons,
  generateShareIcon
} from 'react-share';
import ClipLoader from 'halogen/ClipLoader';
import { quotesArr } from '../../../components/generator/constants/QuotesText';
import uuid from 'uuid';
import Image from '../../../components/helpers/Image.jsx';
import './Chromatic.css';

export default class Chromatic extends Component {

  renderLoading() {
    return (
      <div className="chromatic-loading">
        <ClipLoader color="#333" size="60px" margin="4px"/>
        <div className="chromatic-loading-text">
          Loading ...
        </div>
      </div>
    )
  }

  renderFont() {
    const {
      example
    } = this.props;

    const randomQuote = quotesArr[Math.floor(Math.random() * quotesArr.length)];
    const quote = randomQuote.quote;
    const author = randomQuote.author;
    let quoteLetters = [];
    let authorLetters = [];

    const imageLetters = example[0].font;

    for (let i = 0, len = quote.length; i < len; i++) {
      for (let j = 0; j < imageLetters.length; j++) {
        if (imageLetters[j].letter === quote[i]) {
          quoteLetters.push(imageLetters[j].image);
          break;
        }
      }
    }

    for (var i = 0, len = author.length; i < len; i++) {
      for (let j = 0; j < imageLetters.length; j++) {
        if (imageLetters[j].letter === author[i]) {
          authorLetters.push(imageLetters[j].image);
          break;
        }
      }
    }

    console.log(quoteLetters, authorLetters);

    return (
      <div className="chromatic-quote-container">
        {quoteLetters.map((quoteLetter) => {
          return (
            <Image
              key={uuid.v4()}
              src={quoteLetter}
              alt='quote'
              className="chromatic-quote-letter-image" />
          )
        })}
        <div>
          {authorLetters.map((authorLetter) => {
            return (
              <Image key={uuid.v4()}
                src={authorLetter}
                alt='quote'
                className="chromatic-author-letter-image" />
            )
          })}
        </div>
      </div>
    )
  }
  render () {
    const {
      FacebookShareButton,
      TwitterShareButton,
    } = ShareButtons;

    const {
      loading
    } = this.props;

    const TwitterIcon = generateShareIcon('twitter');
    const FacebookIcon = generateShareIcon('facebook');

    return (
      <div>
        <div className="chromatic-main-body">
          <div className="chromatic-examples">
            {loading
              ? this.renderLoading()
              : this.renderFont()}
          </div>
        </div>
        <div className="chromatic-footer">
          <div className="chromatic-share-this-text">
            Share this:
          </div>
          <FacebookShareButton
            url='https://www.mixfont.com/chromatic'
            title='Fonts Meet Images: A showcase by Mixfont'
            className="round-share-button">
            <FacebookIcon
              size={32}
              round />
          </FacebookShareButton>
          <TwitterShareButton
            url='https://www.mixfont.com/chromatic'
            title='🎁🎉 Fonts Meet Images 🎈🎉'
            via='mixfont'
            hashtags={['webdesign', 'css3', 'css', 'ui']}
            className="round-share-button">
            <TwitterIcon
              size={32}
              round />
          </TwitterShareButton>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/chromatic/Chromatic.jsx